import { Component, inject, input, OnChanges, output, SimpleChanges } from '@angular/core';
import { MsgType } from 'matrix-js-sdk';
import { DisplayMessage } from '../../sb-model/display-message';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Room } from '../../../../../shared-api/room';
import { MatrixService } from '../../../../services/matrix/matrix.service';
import { EditMessageService } from '../../tiptap-editor/editMessage/edit-message.service';

@Component({
  selector: 'app-sb-edit-message',
  imports: [MatIconButton, MatIcon, MatTooltip],
  templateUrl: './sb-edit-message.component.html'
})

/**
 * Dies ist eine Hilfsklasse,
 * die beim bearbeiten einer Nachricht die zu bearbeitende Nachricht setzt,
 * um diese dann an den TipTap-Editor weiterzugeben.
 * Keine Afos enthalten, Begründung: Dies ist nur eine Hilfsklasse
 */
export class SbEditMessageComponent implements OnChanges {
  public message = input<DisplayMessage>();
  room = input<Room>();
  protected toolbarMessageId = output<string>();
  protected readonly MsgType = MsgType;
  protected readonly clientService = inject(MatrixService);
  private readonly editMessageService = inject(EditMessageService);
  private messagedto: DisplayMessage | undefined;

  toogleEdit(): void {
    if (this.messagedto) {
      this.editMessageService.setMessageIntoEditor(this.messagedto);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message']) {
      this.messagedto = this.message();
    }
  }
}
